module.exports = __webpack_public_path__ + "img/57_10.db473902.png";